import {
  Statut as SatutDossier,
  StatutLibelle as StatutLibelleDossiers,
  StatutBadgeType as StatutBadgeTypeDossiers,
} from '@/features/domaine/types/opco/Dossier/Statut'

export const Statut: readonly SatutDossier[] = [
  'EnCoursAnalyse',
  'AttentePiecesInstruction',
  'AttentePiecesReglement',
  'RelanceAvantCloture',
  'Cloture',
  'Accorde',
  'Annule',
  'Refuse',
  'Transmis',
] as const

export type Statut = (typeof Statut)[number]

export const StatutLibelle = Object.freeze(Object.fromEntries(
  Statut.map((statut) => [statut, StatutLibelleDossiers[statut]]),
)) as Readonly<Record<Statut, string>>

export const StatutBadgeType = Object.freeze(Object.fromEntries(
  Statut.map((statut) => [statut, StatutBadgeTypeDossiers[statut]]),
)) as Readonly<Record<Statut, string>>
